import classNames from 'classnames/bind'
import React, { useEffect, useState } from 'react'
import DialogContent from '@mui/material/DialogContent'
import style from './ImportFilePopup.module.scss'
import { BootstrapDialogTitle } from '../BasicPopup'
import { isDarkTheme } from '~/redux/features'
import { useAppSelector } from '~/app/hooks'
import { ALL_NS } from '~/i18n/namespaces'
import { useTranslation } from 'react-i18next'
import { BootstrapDialog } from '.'
import ImportFileComponent from './ImportFileComponent'
import { ImportFilePopupProps } from './ImportFilePopup.model'
import { EFButton } from '~/components/EFButton/EFButton.component'
import { EFFooterDialogWrapper } from '~/components/EFStyledComponents'

const cx = classNames.bind(style)

export function ImportFilePopup(props: ImportFilePopupProps) {
  const { t } = useTranslation(ALL_NS)
  const {
    title,
    typeName,
    maxWidth = 'sm',
    fullWidth = false,
    open,
    onClose,
    onUpload,
    fileTypes,
    multiple = true,
    progress = 0,
    isLoading = false,
    uploadingFileCount,
    ...otherProps
  } = props
  const isDark = useAppSelector(isDarkTheme)

  const [files, setFiles] = useState<File[]>([])

  const handleClose = (isOk: boolean) => {
    if (isOk) {
      onUpload(files)
      return
    }
    onClose()
  }

  // Set files array to empty when open dialog
  useEffect(() => {
    setFiles([])
    return () => {
      setFiles([])
    }
  }, [open])

  return (
    <div className={cx('wrapper')}>
      <BootstrapDialog
        {...otherProps}
        maxWidth={maxWidth}
        fullWidth={fullWidth}
        keepMounted={false}
        onClose={(_e, reason) => (reason === 'backdropClick' ? {} : handleClose(false))}
        aria-labelledby='customized-dialog-title'
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            background: isDark ? 'var(--dark-gray-background)' : '',
            color: isDark ? 'white' : 'var(--dark)'
          }
        }}
      >
        <BootstrapDialogTitle
          id='import'
          onClose={onClose}
        >
          <div style={{ fontSize: 'var(--fs-lg)' }}>{title}</div>
        </BootstrapDialogTitle>
        <DialogContent className={cx('content')}>
          <ImportFileComponent
            files={files}
            setFiles={setFiles}
            fileTypes={fileTypes}
            isLoading={isLoading}
            progress={progress}
            typeName={typeName}
            uploadingFileCount={uploadingFileCount}
            multiple={multiple}
          />
          <EFFooterDialogWrapper>
            <EFButton
              className='button-text'
              onClick={() => handleClose(false)}
              sx={{ mr: 1 }}
            >
              {t('MessageButton_Cancel')}
            </EFButton>
            <EFButton
              disabled={files.length === 0 || isLoading}
              onClick={() => handleClose(true)}
            >
              {t('MessageButton_Upload')}
            </EFButton>
          </EFFooterDialogWrapper>
        </DialogContent>
      </BootstrapDialog>
    </div>
  )
}
